import LocalizedStrings from '../Localization/localization';

export default {
    charly: {
        name: {
            default: 'Home',
            en: 'Home',
            es: 'Página principal',
            de: 'Startseite',
            fr: 'Home',
        },
        tutorialIds: [0, 1, 2, 3, 11, 12],
    },
    inside: {
        name: {
            default: 'Content viewer',
            en: 'Content viewer',
            es: 'Visor de contenido',
            de: 'Inhalte anzeigen',
            fr: 'Regard sur le contenu',
        },
        tutorialIds: [3, 14, 13],
    },
    editor: {
        name: {
            default: LocalizedStrings.editor,
            en: LocalizedStrings.editor,
            es: LocalizedStrings.editor,
            de: LocalizedStrings.editor,
            fr: LocalizedStrings.editor,
        },
        tutorialIds: [10, 4, 13],
    },
    library: {
        name: {
            default: LocalizedStrings.library,
            en: LocalizedStrings.library,
            es: LocalizedStrings.library,
            de: LocalizedStrings.library,
            fr: LocalizedStrings.library,
        },
        tutorialIds: [10, 5, 13],
    },
    users: {
        name: {
            default: LocalizedStrings.users,
            en: LocalizedStrings.users,
            es: LocalizedStrings.users,
            de: LocalizedStrings.users,
            fr: LocalizedStrings.users,
        },
        tutorialIds: [10, 6, 13],
    },
    notifications: {
        name: {
            default: LocalizedStrings.notifications,
            en: LocalizedStrings.notifications,
            es: LocalizedStrings.notifications,
            de: LocalizedStrings.notifications,
            fr: LocalizedStrings.notifications,
        },
        tutorialIds: [10, 7, 13],
    },
    shares: {
        name: {
            default: LocalizedStrings.shares,
            en: LocalizedStrings.shares,
            es: LocalizedStrings.shares,
            de: LocalizedStrings.shares,
            fr: LocalizedStrings.shares,
        },
        tutorialIds: [10, 8, 13],
    },
    visibilities: {
        name: {
            default: LocalizedStrings.visibilities,
            en: LocalizedStrings.visibilities,
            es: LocalizedStrings.visibilities,
            de: LocalizedStrings.visibilities,
            fr: LocalizedStrings.visibilities,
        },
        tutorialIds: [10, 13],
    },
    publish: {
        name: {
            default: LocalizedStrings.publish,
            en: LocalizedStrings.publish,
            es: LocalizedStrings.publish,
            de: LocalizedStrings.publish,
            fr: LocalizedStrings.publish,
        },
        tutorialIds: [10, 9, 13],
    },
};
